const CREATED_AT_WIDTH = 170;
const MEMBER_TEAM_WIDTH = 140;
const STATUS_CREATED_WIDTH = 140;
const ACTIONS_WIDTH = 36;

export const teamsColumns = [
  {
    id: 'group_name',
    label: 'Name / Team lead',
    width: '20%',
    sortable: true,
    minWidth: 198,
  },
  {
    id: 'created_at',
    label: 'Status / Created at',
    width: 180,
    sortable: true,
    minWidth: 180,
  },
  {
    id: 'members_count',
    label: 'Members',
    sortable: true,
    align: 'right',
    minWidth: 118,
  },
  {
    id: 'cards_count',
    label: 'Cards',
    align: 'right',
    minWidth: 170,
  },
  {
    id: 'view-chart',
    label: '',
    minWidth: 220,
  },
  {
    id: 'actions',
    label: '',
    width: ACTIONS_WIDTH,
  },
];

export const membersColumns = [
  {
    id: 'name',
    label: 'Name / Role',
    sortable: true,
    width: '20%',
    minWidth: 180,
  },
  { id: 'teams', label: 'Teams', minWidth: 120 },
  {
    id: 'created_at',
    label: 'Status / Created at',
    sortable: true,
    minWidth: STATUS_CREATED_WIDTH,
  },
  { id: 'email', label: 'E-mail / Telegram', sortable: true, width: 240 },
  { id: 'cards_count', label: 'Cards', sortable: true, align: 'right' },
  { id: 'actions', label: '', width: ACTIONS_WIDTH },
];

export const oneTeamColumns = [
  {
    id: 'name',
    label: 'Name / Role',
    sortable: true,
    width: '18%',
    minWidth: 180,
  },
  { id: 'createdAt', label: 'Status / Created at', minWidth: 240 },
  { id: 'email', label: 'E-mail / Telegram', width: '18%' },
  { id: 'txlimit', label: 'TX / Monthly limit', align: 'right', minWidth: 120 },
  {
    id: 'limit',
    label: 'Cards / Limit',
    align: 'right',
    minWidth: 100,
  },
  { id: 'actions', label: '', width: ACTIONS_WIDTH },
];

export const cardsColumns = [
  { id: 'card_number', label: 'Card details' },
  {
    id: 'status',
    label: 'Status / Created at',
    minWidth: CREATED_AT_WIDTH,
    sortable: true,
  },
  {
    id: 'type',
    label: 'Type',
    minWidth: 110,
  },
  {
    id: 'limit',
    label: 'Monthly limit / TX Limit',
    align: 'right',
    minWidth: 160,
    sortable: true,
  },
  { id: 'user', label: 'Member / Team', minWidth: MEMBER_TEAM_WIDTH },
  { id: 'note', label: 'Note', minWidth: 260 },
  { id: 'actions', label: '', width: ACTIONS_WIDTH },
];

export const transactionsColumns = [
  { id: 'bank', label: 'Card number / Bank' },
  { id: 'member', label: 'Member / Team', minWidth: MEMBER_TEAM_WIDTH },
  { id: 'details', label: 'Transaction details', minWidth: 180 },
  { id: 'merchant', label: 'Merchant', minWidth: 250 },
  { id: 'status', label: 'Status', minWidth: STATUS_CREATED_WIDTH },
  {
    id: 'amount',
    label: 'Amount taken / Charged',
    align: 'right',
    minWidth: 140,
  },
];

export const referralsColumns = [
  { id: 'name', label: 'Name / E-mail', width: '20%' },
  { id: 'daysLeft', label: 'Days left / Joined date' },
  { id: 'rate', label: 'Referral rate', align: 'right' },
  { id: 'income', label: 'Your income', align: 'right' },
];

export const referralsBalanceHistoryColumns = [
  { id: 'date', label: 'Date / Time' },
  { id: 'transaction', label: 'Transaction' },
  { id: 'amount', label: 'Amount', align: 'right' },
];

export const balancesColumns = [
  { id: 'from', label: 'From / Balance', minWidth: 170 },
  { id: 'to', label: 'To / Balance', minWidth: 170 },
  { id: 'date', label: 'Operation / Date' },
  { id: 'status', label: 'Status' },
  { id: 'details', label: 'Operation details', minWidth: 290 },
  { id: 'amount', label: 'Amount', align: 'right', minWidth: 100 },
];
